/** Max paused/offline mutations persisted across app kill. */
export const MAX_OFFLINE_QUEUE_SIZE = 100;

/** Max automatic replay attempts before surfacing failed state. */
export const MUTATION_MAX_FAILURE_COUNT = 5;

/** Base delay for mutation replay backoff (ms). */
export const MUTATION_RETRY_BASE_MS = 3000;

/** Cap mutation replay backoff (ms). */
export const MUTATION_RETRY_MAX_MS = 60000;

/** Mutations with this meta participate in the offline queue. */
export const OFFLINE_QUEUE_META = { offlineQueue: true };
